import { render, staticRenderFns } from "./Forum.vue?vue&type=template&id=34af600b&scoped=true"
import script from "./Forum.vue?vue&type=script&lang=js"
export * from "./Forum.vue?vue&type=script&lang=js"
import style0 from "./Forum.vue?vue&type=style&index=0&id=34af600b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34af600b",
  null
  
)

export default component.exports